import { render, staticRenderFns } from "./adminModulos.vue?vue&type=template&id=6d9372b1"
import script from "./adminModulos.vue?vue&type=script&lang=js"
export * from "./adminModulos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports